export const GATEPASS_TYPE = {
  // NON_RETURNABLE: 'non_returnable',
  // RETURNABLE: 'returnable',
  INTERNAL_CONSUMPTION: 'internal_consumption',
  // RETURN_TO_VENDOR: 'return_to_vendor',
  STOCK_TRANSFER: 'stock_transfer',
};
